import { createSlice } from "@reduxjs/toolkit";

// Initial state for the user
const initialState = {
  //mobileVerification: null,
  firstName: '',
  email: '',
  roles: [],
  isLoggedIn: false, // Add a flag to track login status
};

const userSlice = createSlice({
  name: "user",
  initialState,
  reducers: {
    // Updates user data (called on successful login or registration)
    updateUserData: (state, action) => {
      const updatedData = action.payload;
      state.firstName = updatedData.firstName ?? state.firstName;
      state.email = updatedData.email ?? state.email;
      //state.mobileVerification = updatedData.mobileVerification ?? state.mobileVerification;
      state.roles = updatedData.roles ?? state.roles;
      state.isLoggedIn = updatedData.isLoggedIn ?? state.isLoggedIn;
    },

    // Directly set the user as logged out (useful for logout)
    logoutUser: () => {
      return { ...initialState };  // Reset state and set isLoggedIn to false
    }
  },
});

// Export actions so you can use them in your components
export const { updateUserData, logoutUser } = userSlice.actions;

// Export the reducer to be used in the store
export default userSlice.reducer;
